module.exports = __webpack_public_path__ + "img/1.2d82e0b5.png";